import React from "react";
import { Row, Col } from "antd";
import bg from "../../assets/article1.jpeg";

function AvatarBlock(props) {
  return (
    <Row className="avatar_block_row">
      <Col md={{ span: 16, offset: 4 }} style={{ position: "relative" }}>
        <Row>
          {props.list.map(item => (
            <Col
              md={{ span: 8 }}
              className="avatar_block_col"
              style={{
                display: "flex",
                justifyContent: "center"
              }}
            >
              <div>
                <div
                  style={{
                    position: "relative",
                    height: "200px",
                    width: "200px",
                    margin: "auto",
                    border: "7px solid #fff",
                    borderRadius: "50%",
                    background: `url(${item.image ||
                      props.image}) no-repeat center center`,
                    backgroundSize: "cover"
                  }}
                />
                <div
                  style={{
                    fontSize: "18px",
                    color: "#fff",
                    paddingTop: "10px"
                  }}
                >
                  {item.headline}
                </div>
                <div
                  style={{
                    color: "#fff",
                    textTransform: "italic",
                    fontWeight: 100
                  }}
                >
                  <i>{item.subHeadline}</i>
                </div>
                <p
                  style={{
                    color: "#fff",
                    fontSize: "14px",
                    lineHeight: "18px",
                    padding: "20px"
                  }}
                >
                  {item.body}
                </p>
              </div>
            </Col>
          ))}
        </Row>
      </Col>
      <div
        className="avatar_triangle"
        style={{
          position: "absolute",
          backgroundColor: "#1abc9c",
          width: "100%",
          height: "100%",
          zIndex: -1,
          marginTop: "100px"
        }}
      />
    </Row>
  );
}

export default AvatarBlock;

AvatarBlock.defaultProps = {
  image: bg
};



// WEBPACK FOOTER //
// ./src/components/AvatarBlock/index.js